import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, min } from 'ramda';
import { withFormik } from 'formik';
import ReactCrop from 'react-image-crop';

import { handleError, handleSuccess } from '../../util/forms';
import userActions from '../../redux/user';

import Modal from '../Modal';
import { apiUpdateProfileFiles } from '../../api/user';

const mapDispatch = {
  ...userActions,
};

class ResizeAvatarModal extends Component {
  static propTypes = {
    avatar: PropTypes.object,
    src: PropTypes.string,
    updateUser: PropTypes.func,
  };

  onImageLoaded = (image) => {
    this.props.setFieldValue('width', image.naturalWidth, false);
    this.props.setFieldValue('height', image.naturalHeight, false);
  };

  render() {
    const { onHide, values, handleSubmit, isSubmitting, isValid, setFieldValue, show, src } = this.props;

    return (
      <Modal ignoreBackdrop show={show} onHide={onHide} title="Crop your profile picture">
        <form>
          <Modal.Body>
            <div className="d-flex justify-content-center">
              {src && (
                <ReactCrop
                  src={src}
                  crop={values.crop}
                  onImageLoaded={this.onImageLoaded}
                  onChange={(crop, pcrop) => {
                    setFieldValue('crop', crop, false);
                    setFieldValue('pcrop', pcrop, false);
                  }}
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default compose(
  connect(null, mapDispatch),
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;
      const { width, height, pcrop } = payload;
      const manualCrop = {
        width: width * (pcrop.width * 0.01),
        height: height * (pcrop.height * 0.01),
        x: width * (pcrop.x * 0.01),
        y: height * (pcrop.y * 0.01),
      };

      apiUpdateProfileFiles({ avatar: props.avatar, crop: manualCrop })
        .then(({ data }) => props.updateUser(data))
        .then(() => handleSuccess(formProps))
        .then(props.onHide)
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: () => ({
      width: 0,
      height: 0,
      crop: { aspect: 1 },
    }),
    isInitialValid: true,
    validateOnChange: true,
  }),
)(ResizeAvatarModal);
